import envVariables from "../lib/envHelpers/getEnvVariables";
import deepMerge from "../lib/DeepMerge";
import * as themes from "./modules/";

let theme = themes.default;

theme = deepMerge(theme, themes[envVariables.VENDOR]);

export default theme;
